import Vue from 'vue'
let baseUrl = process.env.VUE_APP_API_WORKSPACE_URL;
if(baseUrl.substring(baseUrl.length - 1) == "/")
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

const STORE_NAME = "cargo";
baseUrl = `${baseUrl}/cargo`;

export default{
    async listar(){
        let response = {
            success: true,
            data: null
        };

        if(Vue.prototype.$db.isIndexedDbEnabled()){
            if(await Vue.prototype.$db.getDailyCacheTable(STORE_NAME) == null){
                await Vue.prototype.$db.deleteAll(STORE_NAME)
            }

            response.data = await Vue.prototype.$db.getAll(STORE_NAME);            
            if((response.data || []).length == 0){
                response = await Vue.prototype.$httpJson.get(baseUrl);
                await Vue.prototype.$db.addAll(STORE_NAME, response.data);
                await Vue.prototype.$db.setDailyCacheTable(STORE_NAME);
            }
        }
        else{
            response = await Vue.prototype.$httpJson.get(baseUrl);
        }

        return response;
    }  
}